import { motion } from "framer-motion";
import { Mic2, Scissors, Rocket } from "lucide-react";
import { PACKAGE_IMAGES } from "@/lib/api";

const pillars = [
    {
        icon: Mic2,
        title: "Enregistrement",
        text: "Micros broadcast, insonorisation, régie pro. Vous arrivez, vous parlez.",
    },
    {
        icon: Scissors,
        title: "Post-production",
        text: "Montage audio/vidéo, shorts verticaux, miniatures. Livraison rapide.",
    },
    {
        icon: Rocket,
        title: "Stratégie",
        text: "Positionnement, ligne éditoriale, diffusion. On vous accompagne pour faire décoller.",
    },
];

export default function About() {
    return (
        <section
            id="studio"
            className="relative py-24 md:py-32 px-6 md:px-12"
            data-testid="about-section"
        >
            <div className="max-w-7xl mx-auto">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-5"
                    >
                        <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-black shadow-[0_20px_80px_rgba(0,0,0,0.5)]">
                            <img
                                src="/studio-gear.png"
                                alt="Matériel pro Mon Séraphin — caméras et micros broadcast"
                                className="w-full h-auto object-contain"
                            />
                            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/80 to-transparent" />
                            <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between">
                                <span className="font-body text-xs uppercase tracking-[0.3em] text-amber-300">
                                    Matériel · Broadcast & cinéma
                                </span>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="lg:col-span-7"
                    >
                        <span className="font-body text-xs uppercase tracking-[0.25em] text-zinc-500">
                            Le studio
                        </span>
                        <h2 className="mt-4 font-display text-4xl md:text-5xl font-light tracking-tight text-white leading-[1.1]">
                            Un lieu conçu pour les voix qui veulent porter.
                        </h2>
                        <p className="mt-6 text-lg text-zinc-400 font-body leading-relaxed max-w-xl">
                            Situé au 5 Boulevard Georges Méliès à Villiers-sur-Marne — Paris Est —
                            Mon Séraphin est accessible en RER A (Noisy-le-Grand – Mont d'Est, 13 min à pied)
                            et en RER E (Villiers-sur-Marne – Le Plessis-Trévise), à 30 minutes de Paris.
                            Le studio des entrepreneurs, créateurs et PME de toute l'Île-de-France
                            qui veulent produire un contenu professionnel sans les
                            tracas techniques. Cadre cinématique, matériel haut de gamme,
                            équipe dévouée.
                        </p>

                        <div className="mt-12 grid sm:grid-cols-3 gap-6">
                            {pillars.map((p, i) => (
                                <motion.div
                                    key={p.title}
                                    initial={{ opacity: 0, y: 15 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: 0.1 * i }}
                                    className="group p-5 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-amber-400/40 transition-all"
                                >
                                    <p.icon className="w-6 h-6 text-amber-400 mb-4" strokeWidth={1.5} />
                                    <h3 className="font-display text-lg text-white font-medium">
                                        {p.title}
                                    </h3>
                                    <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                                        {p.text}
                                    </p>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
